import { render, staticRenderFns } from "./addOccupy.vue?vue&type=template&id=67f09553&scoped=true"
import script from "./addOccupy.vue?vue&type=script&lang=js"
export * from "./addOccupy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f09553",
  null
  
)

export default component.exports